var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "go-elements go-chat-message-btns" }, [
    _c("p", [
      _c(
        "button",
        {
          directives: [
            {
              name: "b-tooltip",
              rawName: "v-b-tooltip.hover.top",
              value: { customClass: "go-tooltip" },
              expression: "{ customClass: 'go-tooltip' }",
              modifiers: { hover: true, top: true },
            },
          ],
          staticClass: "btn go-btn-icon",
          class: { active: _vm.comment.isMyLiked },
          attrs: {
            type: "button",
            "data-toggle": "button",
            "aria-pressed": "false",
            disabled: _vm.isGuest,
            title: _vm.$t("report.like"),
          },
          on: {
            click: function ($event) {
              return _vm.onClickLike(_vm.comment)
            },
          },
        },
        [
          _vm._m(0),
          _vm._v(" "),
          _c("em", [
            _vm._v(
              "\n        " +
                _vm._s(_vm.comment.likeCount ? _vm.comment.likeCount : 0) +
                "\n      "
            ),
          ]),
        ]
      ),
    ]),
    _vm._v(" "),
    _c("p", [
      _c(
        "button",
        {
          directives: [
            {
              name: "b-tooltip",
              rawName: "v-b-tooltip.hover.top",
              value: { customClass: "go-tooltip" },
              expression: "{ customClass: 'go-tooltip' }",
              modifiers: { hover: true, top: true },
            },
          ],
          staticClass: "btn go-btn-icon",
          class: { active: _vm.comment.isMyDisiked },
          attrs: {
            type: "button",
            "data-toggle": "button",
            "aria-pressed": "false",
            disabled: _vm.isGuest,
            title: _vm.$t("report.disLike"),
          },
          on: {
            click: function ($event) {
              return _vm.onClickDislike(_vm.comment)
            },
          },
        },
        [
          _vm._m(1),
          _vm._v(" "),
          _c("em", [
            _vm._v(
              _vm._s(_vm.comment.dislikeCount ? _vm.comment.dislikeCount : 0)
            ),
          ]),
        ]
      ),
    ]),
  ])
}
var staticRenderFns = [
  function () {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c(
      "span",
      {
        staticClass: "go-tooltip-area",
        attrs: {
          "data-toggle": "tooltip",
          title: "",
          "data-original-title": "Like",
        },
      },
      [_c("i", { staticClass: "go-icon-20 go-icon-like" })]
    )
  },
  function () {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c(
      "span",
      {
        staticClass: "go-tooltip-area",
        attrs: {
          "data-toggle": "tooltip",
          title: "",
          "data-original-title": "Dislike",
        },
      },
      [_c("i", { staticClass: "go-icon-20 go-icon-dislike" })]
    )
  },
]
render._withStripped = true

export { render, staticRenderFns }